<section mat-dialog-title>
  <span class="test-title">{{ data.title }}</span>
  <button [mat-dialog-close]="eUnsavedDataDialogResponse.CANCEL">
    <i class="icon-close"></i>
  </button>
</section>
<mat-dialog-content class="test-description">
  <p
    class="text-ui-gray-100"
    [class]="isMobile() ? 'text-base font-medium' : 'text-xl font-semibold text-center'"
  >
    {{ data.description }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    class="=btn-transparent btn-medium font-bold uppercase mr-4"
    [mat-dialog-close]="eUnsavedDataDialogResponse.DISCARD"
  >discard changes</button>
  <button
    class="=btn-transparent btn-medium font-bold uppercase mr-4"
    [mat-dialog-close]="eUnsavedDataDialogResponse.CANCEL"
  >cancel</button>
  <button
    type="submit"
    class="btn-green btn-medium font-bold uppercase"
    [mat-dialog-close]="eUnsavedDataDialogResponse.SAVE"
  >save changes</button>
</mat-dialog-actions>
